
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import PriceDisplay from '@/domains/jobs/components/JobCreate/PriceDisplay.vue'

@Component({
  components: { PriceDisplay }
})
export default class TranslationOptionCard extends Vue {
  @Prop({ type: String, required: true })
  title!: string

  @Prop({ type: Number, default: 0 })
  price!: number

  @Prop({ type: String, required: true })
  description!: string

  @Prop({ type: String, required: true })
  translationType!: string

  @Prop({ type: String, required: true })
  value!: string

  @Prop({ type: Object, required: true })
  fee!: any
}
